import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { MsgService } from 'app/main/components/msg/msg.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GolizaService } from '../goliza.service';

@Component({
  selector: 'app-goliza',
  templateUrl: './goliza.component.html',
  styleUrls: ['./goliza.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GolizaComponent implements OnInit {

  public attemptCount: number = 0;
  public attempts: number[] = [];
  public attemptControl: FormControl = new FormControl();
  public golizaForm: FormGroup;
  public folio: String = "";
  public isValidFolio: Boolean = true;
  public isFinished: Boolean = false;
  public isSaving: Boolean = false;
  public isExists: Boolean = false;
  public type:String = "";


  constructor(
    private _fuseConfigService: FuseConfigService
    , private _msgService: MsgService
    , private _formBuilder: FormBuilder
    , private _activatedRoute: ActivatedRoute
    , private _golizaService: GolizaService
    , private _router: Router,
  ) {
    this.attemptCount = 0;
    this.folio = this._activatedRoute.snapshot.params.noTicket;
    this.type = this._activatedRoute.snapshot.params.type;
    this._golizaService.onAttempChange.subscribe(c => {
      if (c) {
        this.isValidFolio = c.isValid;
        this.attemptCount = c.attempts;
        this.isExists = c.isExists;
      }
    });
  }

  initForm() {

    this.golizaForm = this._formBuilder.group({
      fullName: new FormControl('', [Validators.required, Validators.maxLength(100)])
      , email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)])
      , phoneNumber: new FormControl('', [Validators.required, Validators.maxLength(10)])
    });

    this.f.email
      .valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this._golizaService
            .getCompetitorByEmail(value)
            .subscribe(competitor => {
              if (competitor || competitor != null) {
                this.f.fullName.setValue(competitor.fullName);
                this.f.phoneNumber.setValue(competitor.phoneNumber);
              }
            });
        }
      });
  }

  public get f(): any {
    return this.golizaForm.controls;
  }

  ngOnInit(): void {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    this._golizaService.getTicketByFolio(this.folio, this.type).finally(() => this.initForm());
  }

  add() {
    if (this.attempts.length > (this.attemptCount - 1)) {
      this._msgService.error("Número  de oportunidades superada :D");
      return;
    }
    let value = this.attemptControl.value;
    if (value && value > 0) {
      this.attempts.push(value);

      this.attemptControl.setValue(undefined);
    }
    else {
      this._msgService.error("Valor incorrecto :(");
    }
  }

  finish() {
    if (this.attempts.length >= this.attemptCount) {
      if (this.golizaForm.invalid) {
        this._msgService.error("Los datos Correo electrónico, Nombre y Teléfono son obligatorios");
        return;
      }

      this._msgService.confirm("¿Enviar participación?").subscribe(c => {
        if (c) { 
          let competitor = this.golizaForm.getRawValue();
          let attemptTicket = {
            folio: this.folio
            , type: this.type
            , attempts: this.attempts.map(c => ({ attemptNumber: c }))
          }
          competitor = { ...competitor, attemptTickets: [attemptTicket] }
          this.isSaving = true;
          this._golizaService.postCompetitor(competitor).then(c => {
            this.isFinished = true;
          }).finally(() => this.isSaving = false);
        }
      });

    }
    else {
      this._msgService.error(`Aún te quedan ${(this.attemptCount - this.attempts.length)} intentos :D `);
    }
  }

  return() {
    this._router.navigateByUrl(`home`);
  }
}
